module.exports = __webpack_public_path__ + "static/dior-c5fa8c234f84972ee580af04d450c6ae.jpg";